import * as yup from 'yup';
import { CoordinatesSchema } from '../../../common';
import { values, WoundEmergence, WoundType } from '../../../enums';

export const WoundInitialDescriptionSchema = yup.object({
  initialDate: yup
    .date()
    .required()
    .default(() => new Date()),
  woundType: yup.mixed<WoundType>().oneOf(values(WoundType)).required('Angabe erforderlich'),
  emergenceLocation: yup
    .mixed<WoundEmergence>()
    .oneOf(values(WoundEmergence))
    .required('Angabe erforderlich'),
  woundLocationCoordinates: CoordinatesSchema.nullable(),
  locationDescription: yup.string().nullable(),
});

export const WoundInitialInformationSchema = WoundInitialDescriptionSchema.concat(
  yup.object({
    id: yup.string().required(),
  }),
);

export type IWoundInitialDescription = yup.InferType<typeof WoundInitialInformationSchema>;

export const WoundInitialDescriptionCreateSchema = WoundInitialDescriptionSchema.concat(
  yup.object({
    residentId: yup.string().required(),
  }),
);
export type IWoundInitialDescriptionCreate = yup.InferType<
  typeof WoundInitialDescriptionCreateSchema
>;
export type IWoundInitialDescriptionUpdate = yup.InferType<typeof WoundInitialDescriptionSchema>;
